import { NgModule } from '@angular/core';
import { ModifyFieldConfigPipe } from "./modify-field-config-label.pipe";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [CommonModule],
    exports: [ModifyFieldConfigPipe],
    declarations: [ModifyFieldConfigPipe],
    providers: [ModifyFieldConfigPipe],
})
export class ModifyFieldConfigLabelModule {
}
